import React, { Component } from "react";
import AttachItem from "./components/SlideUpload/AttachItem";
import axios from "../../utils/axiosInstance";
import _ from "lodash";
import { connect } from "react-redux";
import { Dropzone } from "../../components";
import { Notify } from "../../components";
import StorageAlert from "./components/SlideUpload/StorageAlert";
import { Tooltip } from 'react-tooltip';
import {
  showSnackBarComponent,
  setFileUploadProgress,
  setFileCanceller,
  resetSlideUploadState,
  loadSlideboxDirDataList,
  refreshWorklist,
  getAllCaseDetailsTabsInfoAction,
} from "./actions/slidebox-action";
import { getUserDetailsAction } from "../../actions/global-action";
import { getNotificationsAction } from "../../pages/notifications/actions/notification-actions";

import { useDateFormat } from "../adminDashboard/components/DashboardItems/useFormat";
import { FeatureGate } from "../../utils/FeatureGate";

import "./SlideBox-upload.scss";

import UploadIcon from "../../assets/icons/upload.svg";
import { PrimaryButton } from "../../components";

class SlideBoxUpload extends Component {
  state = {
    files: [],
    fileEdit: false,
    changedFileName: null,
    fileSavingS3Path: null,
    uplodFileIndex: null,
    fileNameExits: false,
    errorCount: 0,
    defaultSelectedStain: "H&E",
    showMoveFilePopup: false,
    storageLimitExceed: false,
    storageIsExceedPopup: false,
    DocumentTypes: ["doc", "docx", "xls", "xlsx", "pdf", "bmp"],
  };

  componentDidMount() {
    const { parentFiles } = this.props;

    if (parentFiles) {
      let temp = this.normalizeFile(parentFiles);
      this.setState({ files: temp });
    }

    if (this.props.fileList.length === 0) {
      this.props.resetUploadState();
    }

  }

  openMoveFile = () => {
    this.setState({
      showMoveFilePopup: true,
    });
  };

  closeMoveFile = () => {
    this.setState({ showMoveFilePopup: false });
  };

  normalizeFile = (files) => {
    let tempFiles = [];
    let newFiles;

    for (let i = 0; i < files.length; i++) {
      const nameSplitted = files[i].name.split(".");
      const extention = nameSplitted[nameSplitted.length - 1];
      const isComplexImage = this.checkImageIsComplex(extention);

      try {
        if (isComplexImage) {
          files[i]["checked"] = true;
          tempFiles[i] = files[i];
        } else {
          throw new TypeError();
        }
      } catch (e) {
        Notify({ value: "Unsupported File Format" });
      }
    }

    if (this.props.selectedFolderData.selectedFolderType !== "case") {
      newFiles = tempFiles.filter((fileData) => {
        const nameSplitted = fileData.name.split(".");

        if (
          this.state.DocumentTypes.some(
            (type) =>
              type === nameSplitted[nameSplitted.length - 1].toLowerCase()
          )
        ) {
          return true;
        } else {
          Notify({ value: "Slides cannot be uploaded as Attachments" });
        }
      });
    } else {
      newFiles = tempFiles;
    }

    return newFiles;
  };

  checkImageIsComplex = (imgtype) => {
    return this.state.DocumentTypes.some(
      (type) => type === imgtype.toLowerCase()
    );
  };

  onUploadFile = async (event) => {
    const files = this.state.files;
    const target = event.target;

    await this.setState({
      files: [...files, ...this.normalizeFile(target.files)],
      errorCount: 0,
    });

    this.checkStorageLimitExceed(this.state.files);
  };

  onDropzonUploadFile = async (dropzoneFiles) => {
    const files = this.state.files;

    await this.setState({
      files: [...files, ...this.normalizeFile(dropzoneFiles)],
      errorCount: 0,
    });

    this.checkStorageLimitExceed(this.state.files);
  };

  toggleUploadFile = (listOfFiles) => {
    const dxAccountId = this.props.loggedUserDetails.dxAccountId;
    const rootPath = "slidebox/" + dxAccountId + "/";
    const rootPathDocument = "documents/" + dxAccountId + "/";
    const filesLength = listOfFiles.length;
    const fileSavingS3Path = rootPath;

    this.setState({ fileSavingS3Path: fileSavingS3Path });

    listOfFiles.forEach((file) => (file.uploadedAt = Date.now()));

    if (listOfFiles.length > 0) {
      listOfFiles.forEach((fileData, index) => {
        const fileSplitedArray = fileData.name.split(".");
        const fileExtention =
          fileSplitedArray[fileSplitedArray.length - 1];

        fileData["extention"] = fileExtention;

        const uploadingIndex =
          index + this.props.fileList.length;

        let filePath;

        if (
          this.state.DocumentTypes.some(
            (type) => type === fileExtention
          )
        ) {
          filePath = rootPathDocument;
        } else {
          filePath = rootPath;
        }

        axios
          .get("api/slidebox/getPresignedPutUrl", {
            params: {
              fileName: filePath + fileData.name,
              fileType: fileData.type,
            },
          })
          .then((response) => {
            this.uploadToS3Direct(
              response.data,
              fileData,
              uploadingIndex,
              filesLength
            );

            this.props.getLoggedUserDetails();
          })
          .catch((e) => console.warn(e));
      });

      this.props.showSnackBarComponent({
        show: true,
        fileList: listOfFiles,
        conversionComplete: null,
        percentCompleted: null,
      });
    }
  };

  uploadToS3Direct = (
    data,
    file,
    fileIndex,
    filesLength
  ) => {
    const fileData = new FormData();

    Object.keys(data.params).forEach((key) => {
      if (key === "content-type") {
        fileData.append(key, "");
      } else {
        fileData.append(key, data.params[key]);
      }
    });

    fileData.append("file", file);

    let config = {
      maxContentLength: Infinity,
      maxBodyLength: Infinity,

      onUploadProgress: (progressEvent) => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) /
          progressEvent.total
        );

        this.props.setFileUploadProgress({
          fileIndex,
          percentCompleted,
        });
      },

      cancelToken: new axios.CancelToken((cancel) => {
        this.props.setFileCanceller({
          fileIndex,
          canceller: cancel,
        });
      }),
    };

    axios
      .post(data.endpoint_url, fileData, config)
      .then((response) => {
        this.handleOnUploadToDataBase(
          response,
          file,
          filesLength
        );

        this.props.getLoggedUserDetails();
      });
  };

  handleOnUploadToDataBase = async (
    response,
    file,
    filesLength
  ) => {
    let fileIndex = this.state.uplodFileIndex
      ? this.state.uplodFileIndex + 1
      : 1;

    await this.setState({
      uplodFileIndex: fileIndex,
    });

    try {
      let data = {
        originalFileName: file.name,
        fileName: file.name,
        fileSize: file.size,
        uniquePath: "slidebox",
        isLargeFile: file.size > 20971520,
        fileIndex: fileIndex,
        filesLength,
        selectedFolderId:
          this.props.selectedListData.selectedList,
        selectedFolderType: "case",
      };

      let fileUploadUrl;

      if (
        file.extention === "doc" ||
        file.extention === "docx" ||
        file.extention === "pdf" ||
        file.extention === "xls" ||
        file.extention === "xlsx" ||
        file.extention === "bmp"
      ) {
        fileUploadUrl =
          "api/slidebox/addSlideboxDocuments";
      } else {
        throw new TypeError();
      }

      axios
        .post(fileUploadUrl, data)
        .then((response) => {
          if (response.data.msg === "success") {
            const selectedCaseId = this.props.selectedListData && this.props.selectedListData.selectedList;
            if (selectedCaseId) {
              this.props.getcaseDetails({
                dirId: selectedCaseId,
                dirType: "case",
              });
            }

            if (filesLength === fileIndex) {
              this.props.navigate("/", {
                state: {
                  folderSelected: true,
                  folderPath:
                    this.state.fileSavingS3Path,
                },
              });
            }

            this.props.getLoggedUserDetails();
          }
        })
        .catch((e) => console.warn(e));
    } catch (error) {
      if (error.name === "TypeError") {
        Notify({ value: "Unsupported file format" });
      } else {
        Notify({ value: "Please select document" });
      }
    }
  };

  onChangeCheck = (index) => {
    const files = this.state.files;

    const tempFile = _.merge({}, files[index], {
      checked: !files[index].checked,
    });

    files[index] = tempFile;

    this.setState({
      files: files,
      errorCount: 0,
    });
  };

  onRemoveFile = async (index) => {
    const files = this.state.files;

    if (files[index]) {
      files.splice(index, 1);
    }

    await this.setState({
      files: files,
      errorCount: 0,
    });

    this.checkStorageLimitExceed(this.state.files);
  };

  handleOnUpload = (response, folderPath) => {
    if (response) {
      this.props.navigate("/", {
        state: {
          folderSelected: true,
          folderPath: folderPath,
        },
      });

      this.props.getLoggedUserDetails();
    }
  };

  goBack = () => {
    this.props.onClose();
  };

  fileRenameInit = (file, index) => {
    this.setState({
      changedFileName: file.name,
      fileEdit: true,
      selectedFileToRename: index,
    });
  };

  fileNameChangeDone = (
    file,
    editFileIndex,
    changedFileNameState
  ) => {
    const modifyFile = new File(
      [file],
      changedFileNameState,
      {
        type: file.type,
      }
    );

    modifyFile["checked"] = true;

    const filesList = this.state.files;

    const modifiedFilesList = filesList.map(
      (data, index) => {
        if (
          index === editFileIndex &&
          changedFileNameState
        ) {
          return modifyFile;
        } else {
          return data;
        }
      }
    );

    this.setState({
      files: modifiedFilesList,
      fileEdit: false,
      errorCount: 0,
    });
  };

  showWarning = (event) => {
    event.preventDefault();

    Notify({
      value: "Please check the agreement!!",
    });
  };

  onClickUpload = (event) => {
    if (this.state.fileExits)
      return this.showWarning(event);

    if (!this.state.storageLimitExceed) {
      const files = this.state.files;

      const filesToBeUploaded = files.filter(
        (file) => file.checked
      );

      this.toggleUploadFile(filesToBeUploaded);

      this.props.getLoggedUserDetails();
      this.props.onClose();
    } else {
      this.setState({
        storageIsExceedPopup: true,
      });
    }
  };

  setFileNameStateError = (status) => {
    const errorCount = status
      ? this.state.errorCount + 1
      : this.state.errorCount == 0
        ? 0
        : this.state.errorCount - 1;

    this.setState({
      fileNameExits: status,
      errorCount: errorCount,
    });
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  checkStorageLimitExceed = (files) => {
    const { storageLimit, storageUsed } =
      this.props.loggedUserDetails;

    const currentUploadSize = files.reduce(
      (a, file) => a + file.size,
      0
    );

    const totalCurrentFilesSize =
      currentUploadSize + storageUsed;

    if (totalCurrentFilesSize > storageLimit) {
      this.setState({
        storageLimitExceed: true,
      });

      return true;
    } else {
      this.setState({
        storageLimitExceed: false,
      });

      return false;
    }
  };

  closeStorageExceedPopup = () => {
    this.setState({
      storageIsExceedPopup: false,
    });
  };

  render() {
    const {
      files,
      changedFileName,
      errorCount,
    } = this.state;

    return (
      <div
        className="slidebox-upload-page"
        data-test="uploadFileContainer"
      >
        <FeatureGate feature="patient_level_information">
          <div className="patient-details">
            <span className="patient-name">
              {this.props.patientDetails.middleName ===
                undefined
                ? this.props.patientDetails.firstName +
                " " +
                this.props.patientDetails.lastName
                : this.props.patientDetails.firstName +
                " " +
                this.props.patientDetails.middleName +
                " " +
                this.props.patientDetails.lastName}
            </span>

            <div className="mrn-dob-age">
              <span>
                MRN Number:{" "}
                {this.props.patientDetails.mrnNumber}
              </span>

              <span>
                D.O.B:{" "}
                {useDateFormat({
                  date:
                    this.props.patientDetails.dob,
                })}
              </span>

              <span>
                AGE: {this.props.age} years
              </span>
            </div>
          </div>
        </FeatureGate>

        <div className="slidebox-upload-container">
          <div
            className="upload-content"
            id="upload-content-area"
          >
            <div className="container">
              <div className="upload-area">
                <div className="upload-area-border">
                  <div className="drag-and-drop-wrapper">
                    <img
                      src={UploadIcon}
                      alt="drag and drop"
                      data-test="uploadIcon"
                    />

                    <Dropzone
                      setDragAndDropFiles={
                        this.onDropzonUploadFile
                      }
                    />
                  </div>

                  <div className="input-file-wrapper">
                    <button>
                      CHOOSE FILES
                    </button>

                    <input
                      multiple
                      onChange={this.onUploadFile}
                      type="file"
                      data-test="upload-file"
                    />
                  </div>
                </div>
              </div>

              <div className="select-item-header">
                {files.length > 0 && (
                  <React.Fragment>
                    <span>File name</span>
                  </React.Fragment>
                )}
              </div>

              <div
                className="list-items"
                id="uploadedFilesListContainer"
              >
                {files.map((file, index) => (
                  <AttachItem
                    changedFileName={
                      changedFileName
                    }
                    key={index}
                    file={file}
                    index={index}
                    fileNameEditDone={
                      this.fileNameChangeDone
                    }
                    onChangeCheck={
                      this.onChangeCheck
                    }
                    onRemoveFile={
                      this.onRemoveFile
                    }
                    userId={this.props.id}
                    uploadFileNameError={
                      this.setFileNameStateError
                    }
                    isAttachment
                  />
                ))}
              </div>

              <div className="submit-wrapper">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="prompt-bottom">
                    <PrimaryButton
                      id="uploadSlideButton"
                      label="Finish"
                      extraClass="upload-all-btn"
                      disabled={errorCount > 0}
                      onClick={this.onClickUpload}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.storageIsExceedPopup && (
          <StorageAlert
            acceptMessage={
              this.closeStorageExceedPopup
            }
            closeStorageAlert={
              this.closeStorageExceedPopup
            }
          />
        )}

        <Tooltip
          id="upload-slidebox-tooltip"
          place="top"
          type="dark"
          effect="solid"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedUserDetails:
    state.Global.loggedUserDetails,
  fileList: state.SlideBox.fileList,
  folders: state.SlideBox.folders,
  selectedFolderData:
    state.SlideBox.selectedFolderData,
  conversionComplete:
    state.SlideBox.conversionComplete,
  ...state.SlideBox.selectedFolderData,
  newCaseDirId: state.SlideBox.newCaseDirId,
  licenseTypeFeatures:
    state.Global.loggedUserDetails
      .licenseTypeAccessData,
  selectedListData:
    state.SlideBox.selectedListData,
});

const mapDispatchToProps = (dispatch) => ({
  showSnackBarComponent: (payload) =>
    dispatch(showSnackBarComponent(payload)),

  setFileUploadProgress: (payload) =>
    dispatch(setFileUploadProgress(payload)),

  setFileCanceller: (payload) =>
    dispatch(setFileCanceller(payload)),

  getLoggedUserDetails: () =>
    dispatch(getUserDetailsAction()),

  resetUploadState: () =>
    dispatch(resetSlideUploadState()),

  getNotificationList: () =>
    dispatch(getNotificationsAction()),

  loadSlideboxDirDataList: (payload) =>
    dispatch(loadSlideboxDirDataList(payload)),

  refreshWorklist: (payload) =>
    dispatch(refreshWorklist(payload)),

  getcaseDetails: (payload) =>
    dispatch(
      getAllCaseDetailsTabsInfoAction(payload)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlideBoxUpload);